import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../core/services/auth/auth.service';
import { ApiConfigService } from '../../ssr-services/api-config/api-config.service';
import { CacheService } from '../../ssr-services/cache/cache.service';

interface ContactUsResult {
  email: string;
  name: string;
  number: null;
  message: string;
  countryCode?: string;
  esimId?: string;
  customerId: string;
  subscriptionId?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  protected http = inject(HttpClient);

  protected apiConfig = inject(ApiConfigService);

  protected cacheService = inject(CacheService);

  protected authService = inject(AuthService);

  /**
   * Auto calls api based on user type
   */
  public submitContactUsForm(data: {
    email: string;
    countryCode?: string;
    message?: string;
    name: string;
    number?: string;
    deviceInfo?: string;
    subscriptionId?: string;
    esimId?: string;
  }): Observable<boolean> {
    return this.http
      .post<ContactUsResult>(
        this.apiConfig.url(
          this.authService.isAuthenticated() ? 'create-request' : 'create-request/withoutToken'
        ),
        {
          ...data,
          message: data.message || '-',
          customerId: this.cacheService.cachedContent()?.cache.customerId,
        }
      )
      .pipe(map(() => true));
  }
}
